export class Dispatch {
    public id: number;
    public date: string;
    public month: string;
    public vehicle_id: number;
    public dispatch_group_id: number;
    public created: string;
    constructor(id: number, vehicle_id: number, dispatch_group_id: number, created: string
                , date?: string, month?: string) {
        this.id = id;
        this.vehicle_id = vehicle_id;
        this.dispatch_group_id = dispatch_group_id;
        this.created = created;
        this.date = date;
        this.month = month;
    }
}

export class DispatchCreate {
    public date: string;
    public month: string;
    public vehicle_id: number;
    public dispatch_group_id: number;
    public created: string;
    constructor(vehicle_id: number, dispatch_group_id: number, date?: string, month?: string) {
        this.vehicle_id = vehicle_id;
        this.dispatch_group_id = dispatch_group_id;
        this.date = date;
        this.month = month;
    }
}
